import React from 'react';
import { save } from '../../services/stacks';
import { Alert } from '@mui/material';

const UserExtensions = ({ userExtensionsFileName, userExtensions, setUserExtensions, filterExtensions, setOpenSnackBar, setErrorMsg }) => {
    // Function to remove an extension from userExtensions
    async function removeExtension(extension) {
        const newData = userExtensions.filter((ext) => ext.name !== extension.name);
        setUserExtensions(newData);
        save(
            { fileName: userExtensionsFileName, content: JSON.stringify(newData) },
            { encrypt: false }
        ).then((res) => {
            console.log('saving while updating userExtensions.json with new values', { res });
            if (res?.success) {
                // Use alert to notify user of changes applied
                setErrorMsg({ severity: 'success', msg: `Extension's removed successfully!` });
                setOpenSnackBar(true);
            } else {
                setUserExtensions(userExtensions);
                setErrorMsg({ severity: 'error', msg: `Error's removing extension!` });
                setOpenSnackBar(true);
            }
        });
    };

    async function removeAllExtension() {
        const res = await save({ fileName: userExtensionsFileName, content: JSON.stringify([]) }, { encrypt: false, verify: false });
        setOpenSnackBar(true);
        if (res?.success) {
            setUserExtensions([]);
            setErrorMsg({ severity: 'success', msg: 'Extension removed successfully!' });
        } else {
            setErrorMsg({ severity: 'error', msg: 'Extension removed failed!!!' });
        }
    }

    return (
        <>
            <div className="ext-grid">
                {filterExtensions(userExtensions).map((extension, index) => (
                    <div className="ext-card" key={index}>
                        <img src={extension.image.value} alt={extension.name.value} className="ext-card-image" />
                        <div className="ext-card-content">
                            <h3 className="ext-card-title">{extension.name.value}</h3>
                            <p className="ext-card-description">{extension.info}</p>
                            <button className="ext-card-button remove" onClick={() => removeExtension(extension)}>
                                Remove
                            </button>
                        </div>
                    </div>
                ))}
            </div>
            {userExtensions.length > 0 && (
                <div className='remove-all-extension'>
                    <button className="ext-card-button remove" onClick={removeAllExtension}>
                        Remove All Extensions
                    </button>
                </div>

            )}
        </>

    );
};

export default UserExtensions;